import { useMemo } from 'react';

import { useUserSelector } from '@occc-app/App/AppContext';
import { Retailer_Network_User_Role, User_Role } from '@occc/graphql';

import { useRetailerNetworkContext } from './retailer-network-context';

export const useRetailerNetworkUserSelector = () => {
  const user = useUserSelector();
  const { retailerNetworkUser } = useRetailerNetworkContext();

  return useMemo(() => {
    const isRetailerConnectUserRole = user?.userRole === User_Role.RcUser;
    const retailerNetworkUserRole = retailerNetworkUser?.role ?? null;

    const isRetailerNetworkAdmin =
      isRetailerConnectUserRole &&
      retailerNetworkUserRole === Retailer_Network_User_Role.RetailerNetworkAdmin;
    const isRetailerNetworkUser =
      isRetailerConnectUserRole &&
      retailerNetworkUserRole === Retailer_Network_User_Role.RetailerNetworkUser;
    const isRetailerNetworkSiteAdmin =
      isRetailerConnectUserRole && retailerNetworkUserRole === Retailer_Network_User_Role.SiteAdmin;
    const isRetailerNetworkSiteUser =
      isRetailerConnectUserRole && retailerNetworkUserRole === Retailer_Network_User_Role.SiteUser;

    const isRetailerNetworkUserRole = isRetailerNetworkAdmin || isRetailerNetworkUser;
    const isRetailerNetworkSiteUserRole = isRetailerNetworkSiteAdmin || isRetailerNetworkSiteUser;

    return {
      retailerNetworkUserOpenCommerceUserUuid: retailerNetworkUser?.openCommerceUser?.uuid,
      retailerNetworkUserUuid: retailerNetworkUser?.uuid,
      retailerNetworkUserEmail: retailerNetworkUser?.openCommerceUser?.email,
      retailerNetworkUserName: retailerNetworkUser?.openCommerceUser?.name,
      retailerNetworkUserRole,
      isRetailerNetworkAdmin,
      isRetailerNetworkUser,
      isRetailerNetworkSiteAdmin,
      isRetailerNetworkSiteUser,
      isRetailerNetworkUserRole,
      isRetailerNetworkSiteUserRole,
    };
  }, [user?.userRole, retailerNetworkUser]);
};
